import React from "react";

export const AppContext = React.createContext<any>(null);

export const useAppContext = () => React.useContext(AppContext)